import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "vip-level"
}
const _hoisted_4 = { class: "validity-time" }
const _hoisted_5 = { style: {"padding":"0 !important"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text" }

import { ref, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { memberChangeFlag, UpmemberChangeFlag } from '@/apis/membership'
import { useStore } from 'vuex'
import { getVipCombo, getVipSpecial } from '@/apis/usercenter'
import { useRequest } from '@/util/useLoading'
import PwdSecurity from '../PwdSecurity/PwdSecurity1.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const dialogVisible = ref(false) // 弹窗显示
const membership = store.getters.membership // 会员等级信息
const tagList: any = ref([]) // 会员等级说明
const pwdSecurity1 = ref() // 修改密码
const [loading, api] = useRequest(getVipCombo)

const iconVipSpecial = require('../../assets/image/vipImg/icon_vip_special@2x.png')
const iconVipWhite = require('../../assets/image/vipImg/icon_vip_white@2x.png')
// 特殊会员单独接口获取
if (membership.specialType === 1) {
  getVipSpecial().then(res => {
    tagList.value = res.data?.tagList
  })
} else {
  api().then((res) => {
    if (membership.templateLevel) {
      tagList.value = res.data[membership.templateLevel - 1]?.tagList
    }
  })
}

onMounted(() => {
  getMmemberChangeFlag()
})
const getMmemberChangeFlag = () => {
  memberChangeFlag().then((res: any) => {
    if (res.code === '0') {
      if (res.data === false) {
        dialogVisible.value = true
        return
      }
    }
    // 会员弹窗没问题后调是否需要修改密码弹窗
    pwdSecurity1.value.openModal()
  })
}
const closeModal = () => {
  UpmemberChangeFlag().then((res: any) => {
    if (res.code === '0') {
      dialogVisible.value = false
      // 获取是否修改密码状态，建议用户修改密码
      pwdSecurity1.value.openModal()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
        width: "600px",
        "custom-class": "levelChange",
        "close-on-click-modal": false,
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["wrap", _unref(membership).templateLevel === 1
        ? 'bg1'
        : _unref(membership).templateLevel === 2
          ? 'bg2'
          : _unref(membership).templateLevel === 3
            ? 'bg3'
            : _unref(membership).templateLevel === 4 ? 'bg4' : 'bg5'
        ])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('会员等级变更！')), 1),
              (_unref(membership).templateLevel)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('您当前的会员等级已变更为V').replace('V', '【' + _unref(membership).membershipTemplateName + '】')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('有效期：') + _unref(membership).expiresDate), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["content-c mt_30", _unref(membership).templateLevel === 1
          ? 'bg-c1'
          : _unref(membership).templateLevel === 2
            ? 'bg-c2'
            : _unref(membership).templateLevel === 3
              ? 'bg-c3'
              : _unref(membership).templateLevel === 4 ? 'bg-c4' : 'bg-c5'
          ])
            }, [
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.membershipTagId,
                    class: "list flex ter"
                  }, [
                    _createElementVNode("img", {
                      src: _unref(membership).templateLevel === 5 ? _unref(iconVipSpecial) : _unref(iconVipWhite)
                    }, null, 8, _hoisted_6),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(item.tagName), 1)
                  ]))
                }), 128))
              ])
            ], 2),
            _createVNode(_component_el_button, {
              class: _normalizeClass(["btn mt_20", _unref(membership).templateLevel === 1
          ? 'btn-c1'
          : _unref(membership).templateLevel === 2
            ? 'btn-c2'
            : _unref(membership).templateLevel === 3
              ? 'btn-c3'
              : _unref(membership).templateLevel === 4 ? 'btn-c4' : 'btn-c5'
          ]),
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('立即享用会员')), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(PwdSecurity, {
      ref: (_value, _refs) => {
        _refs['pwdSecurity1'] = _value
        pwdSecurity1.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})